"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conferenceViewLoad = void 0;
var util_1 = require("./util");
exports.conferenceViewLoad = (0, util_1.makeConferenceMapping)('conf-view-load');
